<template>
    <div class="gs-membership-assignments">
        <affiliate-workspace :sections="pricePointsTabs" :current="pricePointsTab" :error-sections="pricePointsErrorTabs" label="Price points" @select="handlePricePointsTabChange">
        <div class="bg-white rounded p-2 mb-2">
            <div v-for="(pricePoint, index) in localMembership.price_points" :key="index">
                <div v-if="pricePointsTab ===
                    'data_sharing_product_price_point_' + pricePoint.id
                    " class="flex flex-col w-full">
                    <div class="flex flex-col w-full bg-white mb-2">
                        <div v-if="post_memberships.length > 0">
                            <div class="flex flex-col">
                                <div class="flex flex-row-reverse w-full gs-membership-toolbar">
                                    <gd-button
                                        size="auto"
                                        variant="primary"
                                        class="mr-4 gs-membership-add"
                                        @click="showPostSaleMembershipBox(index)"
                                    >
                                        <plus-icon class="w-5 h-5 fill-current" />
                                        {{ $t('frontend_product_step8_add_new_membership') }}
                                    </gd-button>
                                </div>

                                <div v-if="pricePoint.memberships && pricePoint.memberships.length > 0" class="mt-6">
                                    <div v-for="(membership, membershipIndex) in pricePoint.memberships"
                                        :key="membershipIndex" class="flex flex-col mt-4">
                                        <div class="flex flex-row gs-membership-row" :class="{
                                            'border-t border-grey-400 border-solid pt-4': membershipIndex > 0,
                                        }">
                                            <div class="w-1/12 mr-8 gs-membership-prefix">{{ $t('frontend_groovesell_addTo') }}</div>
                                            <div class="flex flex-row w-11/12 gs-membership-content">
                                                <div class="w-3/4 flex flex-col gs-membership-details">
                                                    <div class="flex flex-row gs-membership-field">
                                                        <div class="font-bold mr-2 gs-membership-label">
                                                            {{ $t('frontend_membership') }}
                                                        </div>
                                                        <div class="gs-membership-value">
                                                            {{ fetchMembershipName(membership.membership_id) }}
                                                        </div>
                                                    </div>
                                                    <div class="flex flex-row gs-membership-field">
                                                        <div class="font-bold mr-2 gs-membership-label">
                                                            {{ $t('frontend_access_level') }}
                                                        </div>
                                                        <div class="gs-membership-value">
                                                            {{ fetchAccessLevelName(membership.membership_id,
                                                                membership.secret_key) }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="w-1/4 flex flex-row justify-end pr-4 gs-membership-actions">
                                                    <gd-button size="icon" variant="primary"
                                                        :title="$t('frontend_groovesell_delete_membership')" class="mr-2 gs-membership-remove"
                                                        :aria-label="$t('frontend_groovesell_delete_membership')"
                                                        @click="openConfirmModal(index, membershipIndex)">
                                                        <trash-icon class="w-5 h-5 fill-current" />
                                                    </gd-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="mt-6">
                                    <label class="text-grey-dark">{{
                                        $t('frontend_product_step8_no_memberships')
                                    }}</label>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <label class="text-grey-dark">{{
                                $t('frontend_product_step8_no_memberships_added', {memberAppTitle: whitelabelAppData('member').title})
                            }}</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <confirm-modal
            class="gs-membership-confirm"
            name="confirm-modal"
            :message-content="$t('frontend_non_revertable')"
            :button-text="$t('frontend_delete_confirm')"
            button-size="auto"
            @confirm="deletePostSaleMembership"
        />
    </affiliate-workspace>
    </div>
</template>
<script>
import ConfirmModal from "../../components/AffiliateConfirmModal.vue";
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
import TrashIcon from '@/assets/images/icons/TrashIcon.svg';
import PlusIcon from '@/assets/images/icons/PlusIcon.svg';

export default {
    components: { AffiliateWorkspace, ConfirmModal,
        TrashIcon,
        PlusIcon,
    },
    props: {
        showPostSaleMembershipBox: {
            type: Function,
            required: true,
        },
        membership: {
            type: Object,
            required: true,
        },
        pricePointsTabs: {
            type: Array,
            required: true,
        },
        pricePointsTab: {
            type: String,
            required: true,
        },
        handlePricePointsTabChange: {
            type: Function,
            required: true,
        },
        post_memberships: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            localMembership: this.membership,
            index: null,
            postSaleMembershipIndex: null,
        }

    },
    computed: {
        pricePointsErrorTabs() {
            return [];
        },
    },
    watch: {
        localMembership: {
            handler: function (val, oldVal) {
                // this.$emit('update-data', {
                //     key: 'membership',
                //     value: val,
                // });
            },
            deep: true,
        },
    },
    methods: {
        fetchMembershipName(membershipId) {
            const membership = this.post_memberships.find((obj) => {
                return obj.id == membershipId;
            });

            if (membership) {
                return membership.name;
            }
            return 'N/A';
        },
        fetchAccessLevelName(membershipId, accessLevelSecretKey) {
            const membership = this.post_memberships.find((obj) => {
                return obj.id == membershipId;
            });

            if (membership) {
                const accessLevels = membership.access_level;

                if (accessLevels) {
                    const accessLevel = accessLevels.find((obj) => {
                        return obj.secret_key == accessLevelSecretKey;
                    });

                    if (accessLevel) {
                        return accessLevel.name;
                    }
                    return 'N/A';
                }
                return 'N/A';
            }
            return 'N/A';
        },
        openConfirmModal(index, postSaleMembershipIndex) {
            this.$root.$emit('modal-open', 'confirm-modal');
            this.index = index;
            this.postSaleMembershipIndex = postSaleMembershipIndex;
        },
        async deletePostSaleMembership() {
            this.localMembership.price_points[this.index].memberships.splice(this.postSaleMembershipIndex, 1);
        },
    }
}
</script>

<style scoped>
.gs-membership-assignments {
    min-width: 0;
    color: var(--gs-foreground);
}
.gs-membership-row {
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr);
    gap: 16px;
    border-color: var(--gs-border);
}
.gs-membership-prefix {
    width: auto;
    margin: 0;
    color: var(--gs-muted-foreground);
}
.gs-membership-content {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 44px;
    gap: 12px;
    width: 100%;
    min-width: 0;
}
.gs-membership-details {
    width: 100%;
    min-width: 0;
    gap: 12px;
}
.gs-membership-field {
    display: grid;
    grid-template-columns: 120px minmax(0, 1fr);
    gap: 8px;
    align-items: start;
}
.gs-membership-label {
    margin: 0;
}
.gs-membership-value {
    min-width: 0;
    overflow-wrap: anywhere;
    line-height: 1.5;
}
.gs-membership-actions {
    width: 44px;
    padding: 0;
    align-items: flex-start;
}
.gs-membership-remove {
    width: 44px;
    min-width: 44px;
    height: 44px;
    margin: 0;
    padding: 10px;
    background: transparent !important;
    border: 1px solid transparent !important;
    color: var(--gs-danger) !important;
    box-shadow: none !important;
}
.gs-membership-remove:hover {
    background: var(--gs-surface-subtle) !important;
}
.gs-membership-add {
    height: auto;
    min-height: 44px;
    padding: 8px 12px;
    margin-right: 0;
    white-space: normal;
    background: var(--gs-surface) !important;
    border: 1px solid var(--gs-border) !important;
    color: var(--gs-foreground) !important;
    box-shadow: none !important;
}
.gs-membership-add:focus-visible,
.gs-membership-remove:focus-visible {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
}
.gs-membership-assignments ::v-deep .gs-membership-confirm button:last-child {
    background: var(--gs-danger) !important;
    border-color: var(--gs-danger) !important;
    color: var(--gs-primary-foreground) !important;
}
@media (max-width: 640px) {
    .gs-membership-row {
        grid-template-columns: minmax(0, 1fr);
        gap: 8px;
    }
    .gs-membership-field {
        grid-template-columns: minmax(0, 1fr);
        gap: 4px;
    }
    .gs-membership-toolbar {
        justify-content: stretch;
    }
    .gs-membership-add {
        width: 100%;
    }
}
</style>
